var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22.9457 1.67744L19.3172 1.67133C15.2408 1.67133 12.6064 4.51018 12.6064 8.90407V12.2388H8.95817C8.64292 12.2388 8.38763 12.5073 8.38763 12.8384V17.6701C8.38763 18.0013 8.64321 18.2694 8.95817 18.2694H12.6064V30.4613C12.6064 30.7925 12.8617 31.0606 13.177 31.0606H17.9369C18.2521 31.0606 18.5074 30.7922 18.5074 30.4613V18.2694H22.7731C23.0883 18.2694 23.3436 18.0013 23.3436 17.6701L23.3453 12.8384C23.3453 12.6794 23.2851 12.5272 23.1782 12.4146C23.0714 12.3021 22.9259 12.2388 22.7745 12.2388H18.5074V9.41191C18.5074 8.05317 18.8157 7.36341 20.5008 7.36341L22.9451 7.36249C23.26 7.36249 23.5153 7.09405 23.5153 6.76323V2.2767C23.5153 1.94619 23.2603 1.67805 22.9457 1.67744Z","fill":"#8086F2"}));
}

Facebook.defaultProps = {"width":"32","height":"33","viewBox":"0 0 32 33","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
